import { Helmet } from 'react-helmet-async';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import PriceBreakdown from '../components/PriceBreakdown';
import ProblemSection from '../components/ProblemSection';
import SolutionSection from '../components/SolutionSection';
import BenefitsTabs from '../components/BenefitsTabs';
import HowItWorks from '../components/HowItWorks';
import ProductShowcase from '../components/ProductShowcase';
import Testimonials from '../components/Testimonials';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';
import BlogPreview from '../components/BlogPreview';
import FinalCTA from '../components/FinalCTA';
import Footer from '../components/Footer';

const HomePage = () => {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Searchefy',
    url: 'https://searchefy.com',
    logo: 'https://searchefy.com/logo.png',
    description: 'Backlink campaign management platform with 500+ curated sources and unlimited project tracking.',
    founder: {
      '@type': 'Person',
      name: 'Pratish Jain',
      url: 'https://pratishjain.com',
    },
    sameAs: [
      'https://twitter.com/searchefy',
      'https://linkedin.com/company/searchefy',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Searchefy',
    url: 'https://searchefy.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://searchefy.com/blog?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <Helmet>
        <title>Searchefy — Backlink Tracker & Campaign Manager | $9 Lifetime</title>
        <meta
          name="description"
          content="Build backlinks systematically with 500+ curated sources, unlimited project tracking, and real-time analytics. One-time $9 payment for lifetime access."
        />
        <meta
          name="keywords"
          content="backlink tracker, link building tool, backlink campaign manager, lifetime SEO tool, dofollow backlink directory, how to build backlinks free, improve domain authority, backlink spreadsheet alternative"
        />
        <link rel="canonical" href="https://searchefy.com" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://searchefy.com" />
        <meta
          property="og:title"
          content="Searchefy — Backlink Tracker & Campaign Manager | $9 Lifetime"
        />
        <meta
          property="og:description"
          content="Build backlinks systematically with 500+ curated sources, unlimited project tracking, and real-time analytics."
        />
        <meta property="og:image" content="https://searchefy.com/og-image.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://searchefy.com" />
        <meta
          name="twitter:title"
          content="Searchefy — Backlink Tracker & Campaign Manager"
        />
        <meta
          name="twitter:description"
          content="Build backlinks systematically with 500+ curated sources. $9 lifetime access."
        />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(websiteSchema)}
        </script>
      </Helmet>

      <div data-testid="home-page">
        <Navbar />
        <main>
          <Hero />
          <PriceBreakdown />
          <ProblemSection />
          <SolutionSection />
          <BenefitsTabs />
          <HowItWorks />
          <ProductShowcase />
          <Testimonials />
          <Pricing />
          <FAQ />
          <BlogPreview />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
